import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import moment from 'moment';

@Component({
    selector: 'pr-input-slider',
    templateUrl: './pr-input-slider.component.html',
    styleUrls: ['./pr-input-slider.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrInputSliderComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: PrInputSliderComponent,
        },
    ],
    standalone: false
})
export class PrInputSliderComponent implements ControlValueAccessor, Validator {
  @ViewChild('input', { static: true }) inputRef: ElementRef;
  @Input() formControlName: string;
  @Input() derrors: boolean = false;
  @Input() label: string;
  @Input() suffix: string;
  @Input() min: number = 0;
  @Input() max: number = 100;
  @Input() step: number = 1;
  hash =
    Math.random().toString(36).substring(2, 15) +
    Math.random().toString(36).substring(2, 15);

  value;
  touched = false;
  disabled = false;
  onChange = val => {};
  onTouched = () => {};

  @Input() options = [
    { value: true, label: 'Oui', icon: undefined },
    { value: false, label: 'Non', icon: undefined },
  ];

  constructor(private controlContainer: ControlContainer) {}

  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  ngOnInit() {
    if (this.control && this.control.value != null)
      this.value = this.control.value;
    else setTimeout(() => this.writeValue(Number(this.max) / 2), 0);
  }

  get formLabel() {
    return `${this.formControlName}_${this.hash}`;
  }

  onSliderChange(value: number) {
    this.value = value;
    this.onChange(this.value);
  }

  onInputChange($event) {
    $event.value = +String($event.value).replace(',', '.');
    this.value = Number($event.value);
    this.onChange(this.value);
  }

  writeValue(value: any): void {
    this.value = Math.round((value + Number.EPSILON) * 100) / 100;
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
